import {VersionMismatchToastProvider} from '@github-ui/version-mismatch-detector/VersionMismatchToastProvider'

export const ISSUES_VERSION_MISMATCH_APP_NAME = 'issues'

/**
 * Registers the Issues app for the "please refresh" toast that `versionMismatchDetector` shows when a
 * response says the server runs a newer deploy. It renders nothing, so layouts can mount it beside
 * their `Outlet` instead of around it.
 */
export function IssuesVersionMismatchToast() {
  return <VersionMismatchToastProvider appName={ISSUES_VERSION_MISMATCH_APP_NAME}>{null}</VersionMismatchToastProvider>
}
